<template>
  <div>
    <a-form layout="inline" class="form">
      <a-form-item label="过期时间">
        <a-date-picker v-model:value="dateValue" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="addToken">创建访问令牌</a-button>
      </a-form-item>
    </a-form>
    <a-table :dataSource="dataSource" :columns="columns" :pagination="false">
      <template slot="action" slot-scope="text, record">
        <a @click="delete(record.id)">删除</a>
      </template>
    </a-table>
  </div>
</template>

<script>
import moment from "moment";
import accessToken from "@/request/api-manager/accessToken.js";
import { USER_ID } from "@/store/mutation-types";
import Vue from "vue";
export default {
  data() {
    return {
      dateValue: null,
      dataSource: [],
      columns: [
        {
          title: "访问令牌",
          dataIndex: "accessToken",
          key: "accessToken",
        },
        {
          title: "过期时间",
          dataIndex: "expireTime",
          key: "expireTime",
        },
        {
          title: "操作",
          dataIndex: "action",
          key: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      pagination: {
        total: 20,
        current: 1,
        pageSize: 10,
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    delete(id) {
      let self = this;
      accessToken.delete({ id }).then((res) => {
        if (res.success) {
          self.$message.success("删除成功");
        } else {
          self.$message.error("删除失败");
        }
        this.pagination.current = 1;
        this.pagination.pageSize = 10;
        this.getData();
      });
    },
    addToken() {
      let self = this;
      let expireTime = this.dateValue
        ? moment(this.dateValue).format("YYYY-MM-DD")
        : null;
      let userId = Vue.ls.get(USER_ID);
      let params = { expireTime, userId };
      accessToken.add(params).then((res) => {
        if (res.success) {
          self.$message.success("添加成功");
        } else {
          self.$message.error("添加失败");
        }
        this.pagination.current = 1;
        this.pagination.pageSize = 10;
        this.getData();
      });
    },
    getData() {
      let params = {
        pageNo: 1,
        pageSize: -1,
        userId: Vue.ls.get(USER_ID),
      };
      accessToken.list(params).then((res) => {
        this.dataSource = res.result.records;
        this.pagination.total = res.result.total;
      });
    },
  },
};
</script>
<style scoped>
.form {
  padding: 0 0 12px 16px;
}
</style>
